<mat-toolbar class="no-shadow fix">
  <ng-content></ng-content>
  <!-- Expand Button-->
  <button class="mr-1" mat-icon-button *ngIf="showExpandButton" (click)="toggleExpandDetails()">
      <mat-icon>{{ isExpanded ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
  </button>

  <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">

  <!-- Dynamic title-->
  <div fxFlex class="m-l-0" #titleDiv>
    <span class="m-l-10 font-14">{{titleCalc}}</span>
  </div>

    <!-- Previous/Next Button-->
  <div *ngIf="showPreviousNextButtons && isExpanded" style="padding-right: 20px;">
    <button mat-raised-button class="m-r-20" 
    [disabled]="isGridFirstRow" title="{{'global.previous' | translate}}"
    id="{{'buttonPreviousHeaderDetail'}}" type="button"  color="primary" (click)="previousItem()">
      <mat-icon>arrow_back</mat-icon> {{isGridFirstRow ? '' : '(' + (gridIndex - 1) + ')'}} {{'global.previous' | translate}}
    </button>
    
    <button mat-raised-button class="m-r-20" 
    [disabled]="isGridLastRow" title="{{'global.next' | translate}}"
    id="{{'buttonNextHeaderDetail'}}" type="button"  color="primary" (click)="nextItem()">
    {{'global.next' | translate}} {{isGridLastRow ? '' : '(' + (gridIndex + 1) + ')'}} <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>

   <!-- Dynamic buttons-->
  <ng-container *ngFor="let button of getButtons()">
    <div *ngxPermissionsOnly="button.permissions || []">

      <button *ngIf="!button.isActionButtonMore && button.label" mat-raised-button class="m-r-20" 
      [disabled]="!getDefaultBool(false, button.enabled)" title="{{(button.title || button.label || '') | translate}}"
      id="{{'button' + button.actionName + 'HeaderDetail'}}" type="button"  color="{{button.color}}" (click)="sendActionMessage(button.actionName)">
        <mat-icon>{{button.iconName}}</mat-icon> {{(button.label || '') | translate}}
      </button>
      
      <button *ngIf="!button.isActionButtonMore && !button.label" mat-icon-button class="mr-1" 
      [disabled]="!getDefaultBool(false, button.enabled)" title="{{(button.title || button.label || '') | translate}}"
      id="{{'button' + button.actionName + 'HeaderDetail'}}" type="button"  color="{{button.color}}" (click)="sendActionMessage(button.actionName)">
        <mat-icon>{{button.iconName}}</mat-icon>
      </button>

    </div>
  </ng-container>
  
  <div *ngxPermissionsOnly="getPermissionMore()">
      <button mat-icon-button class="m-r-20"  id="buttonMoreHeader"
      type="button" *ngIf="getActionsButtonMore().length > 0"  [matMenuTriggerFor]="menu" aria-label="More">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <ng-container class="p-10" *ngFor="let item of getActionsButtonMore()">
          <div *ngxPermissionsOnly="item.permissions || []">
            <button mat-menu-item  id="{{'button' + item.actionName + 'HeaderDetail'}}" 
            [disabled]="!getDefaultBool(true, item.enabled)" (click)="sendActionMessage(item.actionName)">
              <mat-icon>{{item.iconName}}</mat-icon>
              <span>{{(item.label || '') | translate}}</span>
            </button>
          </div>            
        </ng-container>
      </mat-menu>
  </div>

    <!-- Close Button-->
    <button mat-icon-button *ngIf="showCloseButton" type="button" id="buttonCloseHeaderDetail" class="mr-1" (click)="sendActionMessage('_close')">
      <mat-icon>highlight_off</mat-icon>
    </button>

  </div>
</mat-toolbar>
